import {
  SET_CALENDAR_EVENTS,
  FETCHING_CALENDAR_EVENTS,
  FETCHED_CALENDAR_EVENTS,
  ADD_CALENDAR_EVENT,
  UPDATE_CALENDAR_EVENT,
  DELETE_CALENDAR_EVENT,
  CLEAR_CALENDAR_EVENTS,
  CLEAR_ALL
} from "../actions/constants";
import defaults from "./defaults";

const calendarReducer = (state = defaults.calendar, { type, payload }) => {
  switch (type) {
    case SET_CALENDAR_EVENTS:
      return {
        ...state,
        list: {
          ...state.list,
          [payload.project_id]: payload.events
        },
        fetched: {
          ...state.fetched,
          [payload.project_id]: new Date()
        }
      };

    case FETCHING_CALENDAR_EVENTS:
      return {
        ...state,
        fetching: payload
      };

    case FETCHED_CALENDAR_EVENTS:
      return {
        ...state,
        fetched: {
          ...state.fetched,
          [payload.project_id]: new Date()
        }
      };

    case ADD_CALENDAR_EVENT:
      return {
        ...state,
        list: {
          ...state.list,
          [payload.project_id]: [
            ...(state.list[payload.project_id] || []),
            payload.event
          ]
        }
      };

    case UPDATE_CALENDAR_EVENT:
      return {
        ...state,
        list: {
          ...state.list,
          [payload.project_id]: (state.list[payload.project_id] || []).map(event =>
            event.id === payload.event_id ? { ...event, ...payload.updates } : event
          )
        }
      };

    case DELETE_CALENDAR_EVENT:
      return {
        ...state,
        list: {
          ...state.list,
          [payload.project_id]: (state.list[payload.project_id] || []).filter(
            event => event.id !== payload.event_id
          )
        }
      };

    case CLEAR_CALENDAR_EVENTS:
      return {
        ...state,
        list: {
          ...state.list,
          [payload.project_id]: []
        }
      };

    case CLEAR_ALL:
      return defaults.calendar;

    default:
      return state;
  }
};

export default calendarReducer;
